import { createSelector } from "reselect";

export const getDivisionListState = (state) => state.divisions.list;

export const getDivisionList = createSelector(getDivisionListState, (state) => state.divisions);
export const getIsDivisionListFetching = createSelector(getDivisionListState, (state) => state.isFetching);
